import { defineSlotRecipe } from "@chakra-ui/react";

export const menuRecipe = defineSlotRecipe({
  slots: ["trigger", "content", "item", "separator", "arrow", "positioner"],
  base: {
    trigger: {
      borderWidth: "0 !important",
      _focus: { outline: "0", boxShadow: "none" },
      _focusVisible: { outline: "0", boxShadow: "none" },
    },
    content: {
      borderWidth: "1px",
      borderColor: "blackAlpha.100",
      rounded: "lg",
      shadow: "xl",
      bg: "whiteAlpha.900",
      backdropFilter: "saturate(180%) blur(8px)",
      _dark: { bg: "blackAlpha.800", borderColor: "whiteAlpha.200" },
      p: "2",
      minW: "240px",
    },
    item: {
      rounded: "md",
      px: "3",
      py: "2",
      _hover: { bg: "gray.50" },
      _active: { bg: "gray.100" },
      _dark: {
        _hover: { bg: "whiteAlpha.100" },
        _active: { bg: "whiteAlpha.200" },
      },
    },
    separator: { my: "1" },
  },
});
